export default "__VITE_ASSET__UtqIK1bt__"